module.exports = __webpack_public_path__ + "img/clogo.e25daf9f.png";